import { Grid } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../Provider'
import { OPAccordionItem } from '../../Accordion/OPAccordionItem'
import { OPLoadingCircle } from '../../OPcomponents/OPLoadingcircle'
import '../profile.scss'
import PublicWorkHistoryTable from './PublicWorkHistoryTable'

const PublicWorkhistory = (props: { rowId: number | undefined }): JSX.Element => {
  const { t } = useTranslation()

  const rootStore = useStore()
  const { filteredPublicWorkHistories, publicWorkHistoryLoading } = rootStore.personStore
  const { projects, getAllProjects, loadingInitial } = rootStore.projectStore
  const { validatedUser } = rootStore.loginStore
  const { rowId } = props

  useEffect(() => {
    ;(async () => {
      if (projects.length === 0) await getAllProjects(validatedUser)
    })()
  }, [getAllProjects, projects.length, validatedUser])

  return (
    <Grid container item display='flex'>
      <OPAccordionItem
        setOutsideExpanded={rowId !== undefined}
        title={`${t('WorkHistory.NetumHeader')} (${publicWorkHistoryLoading ? '\u2026' : filteredPublicWorkHistories.length})`}
        content={
          <Grid container className='gridcontainer--workhistory__formpadding'>
            <Grid item xs={12}>
              {publicWorkHistoryLoading || loadingInitial ? <OPLoadingCircle /> : <PublicWorkHistoryTable rowId={rowId} />}
            </Grid>
          </Grid>
        }
      />
    </Grid>
  )
}

export default observer(PublicWorkhistory)
